import React, { useEffect, useState } from 'react';
import { Grid, IconButton, MenuItem } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { routesName } from '../constants/routes-name';
import { ApiManager } from '../services/api';
import { Formik } from 'formik';
import { validationSchema } from '../constants/validationSchema';
import * as yup from 'yup';
import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import useNotification from '../hooks/useNotification';
import { TextFieldWrapper } from '.';
import { useSelector } from 'react-redux';

function Component({ onSuccess = () => {} }) {
  const { user } = useSelector(({ user }) => user);
  console.log('user=>', user);
  const { successNonification, errorNonification } = useNotification();
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);

  const getRoles = async () => {
    const res = await ApiManager.getRoles();
    if (res?.status === 200 && res?.data?.data) {
      setRoles(res?.data?.data);
    }
  };

  const register = async (data) => {
    const res = await ApiManager.register(data);

    if (res?.status === 200) {
      onSuccess();
      successNonification('Successfully registerd');
    } else {
      errorNonification(res?.data?.message || 'Something went wrong');
    }
  };

  useEffect(() => {
    getRoles();
  }, []);

  return (
    <div className="mt-4">
      <Formik
        initialValues={{
          name: '',
          phone: '',
          username: '',
          email: '',
          password: '',
          confirmPassword: '',
          role: '',
          organizationType: user?.organization?.organizationType || '',
          organizationName: user?.organization?.name || '',
          regisstrationNo: user?.organization?.regisstrationNo || '',
          address: user?.organization?.address || '',
          city: user?.organization?.city || '',
          country: user?.organization?.country || '',

          showPassword: false,
          showConfirmPassword: false,
        }}
        validationSchema={yup.object().shape({
          name: validationSchema.name,
          phone: validationSchema.required('Phone'),
          username: validationSchema.required('Username'),
          email: validationSchema.email,
          password: validationSchema.password,
          confirmPassword: validationSchema.confirmPassword,
          role: validationSchema.required('Role'),
        })}
        onSubmit={(values, actions) => {
          try {
            console.log(values);
            register({
              name: values.name,
              phone: values.phone,
              username: values.username,
              email: values.email,
              password: values.password,
              confirmPassword: values.confirmPassword,
              role: values.role,
              organizationType: values.organizationType,
              organizationName: values.organizationName,
              regisstrationNo: values.regisstrationNo,
              address: values.address,
              city: values.city,
              country: values.country,
            });
          } catch (error) {
            console.log(error);
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldValue,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <div className="text-3xl font-bold text-center mb-4">
                Add committee member
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex flex-col gap-2">
                <label className="text-xs">
                  Full Name <span className="text-red-500">*</span>
                </label>
                <TextFieldWrapper
                  placeholder="Name"
                  name="name"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                  helperText={touched.name && errors.name}
                  error={!!touched.name && !!errors.name}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex flex-col gap-2">
                <label className="text-xs">
                  Phone <span className="text-red-500">*</span>
                </label>
                <TextFieldWrapper
                  placeholder="Placeholder"
                  name="phone"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.phone}
                  helperText={touched.phone && errors.phone}
                  error={!!touched.phone && !!errors.phone}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex flex-col gap-2">
                <label className="text-xs">
                  Username <span className="text-red-500">*</span>
                </label>
                <TextFieldWrapper
                  placeholder="Placeholder"
                  name="username"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.username}
                  helperText={touched.username && errors.username}
                  error={!!touched.username && !!errors.username}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex flex-col gap-2">
                <label className="text-xs">
                  Email <span className="text-red-500">*</span>
                </label>
                <TextFieldWrapper
                  placeholder="Placeholder"
                  name="email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  helperText={touched.email && errors.email}
                  error={!!touched.email && !!errors.email}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex flex-col gap-2">
                <label className="text-xs">
                  Password <span className="text-red-500">*</span>
                </label>
                <TextFieldWrapper
                  placeholder="Placeholder"
                  name="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  helperText={touched.password && errors.password}
                  error={!!touched.password && !!errors.password}
                  type={values.showPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        onClick={() =>
                          setFieldValue('showPassword', !values.showPassword)
                        }
                      >
                        {values.showPassword ? (
                          <VisibilityOutlined fontSize="small" />
                        ) : (
                          <VisibilityOffOutlined fontSize="small" />
                        )}
                      </IconButton>
                    ),
                  }}
                />
              </div>
            </Grid>

            <Grid item xs={12}>
              <div className="flex flex-col gap-2">
                <label className="text-xs">
                  Confirm Password <span className="text-red-500">*</span>
                </label>
                <TextFieldWrapper
                  placeholder="Placeholder"
                  name="confirmPassword"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.confirmPassword}
                  helperText={touched.confirmPassword && errors.confirmPassword}
                  error={!!touched.confirmPassword && !!errors.confirmPassword}
                  type={values.showConfirmPassword ? 'text' : 'password'}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        onClick={() =>
                          setFieldValue(
                            'showConfirmPassword',
                            !values.showConfirmPassword
                          )
                        }
                      >
                        {values.showConfirmPassword ? (
                          <VisibilityOutlined fontSize="small" />
                        ) : (
                          <VisibilityOffOutlined fontSize="small" />
                        )}
                      </IconButton>
                    ),
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="flex flex-col gap-2">
                <label className="text-xs">
                  Role <span className="text-red-500">*</span>
                </label>
                <TextFieldWrapper
                  placeholder="Placeholder"
                  select
                  name="role"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.role}
                  helperText={touched.role && errors.role}
                  error={!!touched.role && !!errors.role}
                >
                  <MenuItem value="">
                    <i className="text-gray-500">Select</i>
                  </MenuItem>
                  {roles &&
                    Array.isArray(roles) &&
                    roles.map((option) => (
                      <MenuItem key={option._id} value={option._id}>
                        {option.name}
                      </MenuItem>
                    ))}
                </TextFieldWrapper>
              </div>
            </Grid>
            <Grid item xs={12}>
              <button
                onClick={handleSubmit}
                className="w-full text-md border border-white bg-main text-white hover:text-black border border-1 border-[var(--blue)] text-center px-4 py-2 rounded-full font-bold flex items-center justify-center gap-1 cursor-pointer"
              >
                Sign up
              </button>
            </Grid>
          </Grid>
        )}
      </Formik>
    </div>
  );
}

export default Component;
